export default "__VITE_ASSET__BKajpzPT__"